/* Copyright 2024, LevelBlue Intellectual Property. All rights reserved. */

export const environment = {
	production: true,
	API_BACKEND_URL: window.env?.API_BACKEND_URL,
	MACD_URL: window.env?.MACD_PROD_URL,
	FUSION_URL: window.env?.FUSION_URL,
};
